import { render, staticRenderFns } from "./CliN_Addresses_List.vue?vue&type=template&id=64e93296"
import script from "./CliN_Addresses_List.vue?vue&type=script&lang=js"
export * from "./CliN_Addresses_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports